import { render, staticRenderFns } from "./RegistraPezzi.vue?vue&type=template&id=4d3065aa&scoped=true&"
import script from "./RegistraPezzi.vue?vue&type=script&lang=js&"
export * from "./RegistraPezzi.vue?vue&type=script&lang=js&"
import style0 from "./RegistraPezzi.vue?vue&type=style&index=0&id=4d3065aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3065aa",
  null
  
)

export default component.exports